interface UseBtnSecondaryOptions {
  onClick: () => void
}

interface UseBtnSecondaryReturn {
  handleClick: () => void
}

export const useBtnSecondary = ({ onClick }: UseBtnSecondaryOptions): UseBtnSecondaryReturn => {
  const handleClick = (): void => {
    onClick()
  }

  return {
    handleClick,
  }
}
